import omit from 'lodash/omit';
import merge from 'lodash/merge';
import { type EmployeeDetailed } from '../API/GET/employee/response';
import { type UpdateEmployee } from '../API/PUT/employee/request';

export function employeeDetailedToUpdateEmployee(employeeDetail: EmployeeDetailed): UpdateEmployee {
  return merge(
    omit(employeeDetail, ['id', 'access', 'active', 'contractEnd', 'tags', 'locs', 'optimum']),
    { tags: employeeDetail.tags.map(t => t.id), locs: employeeDetail.locs.map(l => l.id) }
  );
}

export function employeeDetailedMergeUpdateEmployee(
  employeeDetail: EmployeeDetailed,
  updateEmployee: UpdateEmployee
): EmployeeDetailed {
  return { ...employeeDetail, ...omit(updateEmployee, ['tags','locs']) };
}
